export default __webpack_public_path__ + "static/media/vip-coin.3ce3310c.png";